import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import { createTheme, ThemeProvider, Box, CssBaseline } from "@mui/material";

import "/node_modules/flag-icons/css/flag-icons.min.css";

import { themeConfig } from "../../themeConfig";
import Loader from "components/common/Loader";
import Notifier from "components/common/Notification";
import A11yMessage from "components/common/A11yMessage";
import UpgradePlan from "components/modals/UpgradePlan";
import TTSRequestsLimit from "components/modals/TTSRequestsLimit";
import CrazyEggTrackers from "components/CrazyEggTrackers";

const theme = createTheme(themeConfig);
theme.typography.h2 = {
  ...theme.typography.h2,
  [theme.breakpoints.down("sm")]: {
    ...theme.typography.h2,
    lineHeight: "25px",
  },
};
theme.typography.h5 = {
  ...theme.typography.h5,
  [theme.breakpoints.down("sm")]: {
    ...theme.typography.h5,
    fontSize: "15px",
  },
};
theme.typography.subtitle1 = {
  ...theme.typography.subtitle1,
  [theme.breakpoints.down("sm")]: {
    ...theme.typography.subtitle1,
    fontSize: "15px",
  },
};
theme.typography.body1 = {
  ...theme.typography.body1,
  [theme.breakpoints.down("sm")]: {
    ...theme.typography.body1,
    fontSize: "15px",
  },
};
theme.typography.body2 = {
  ...theme.typography.body2,
  [theme.breakpoints.down("sm")]: {
    ...theme.typography.body2,
    fontSize: "15px",
  },
};
theme.components.MuiDialog.styleOverrides.root["& .MuiDialogContent-root"] = {
  ...theme.components.MuiDialog.styleOverrides.root["& .MuiDialogContent-root"],
  minWidth: "100%",
};
theme.components.MuiDialog.styleOverrides.root["& .MuiPaper-root"] = {
  ...theme.components.MuiDialog.styleOverrides.root["& .MuiPaper-root"],
  width: "90%",
};
theme.components.MuiInputBase.styleOverrides.root = {
  ...theme.components.MuiInputBase.styleOverrides.root,
  [theme.breakpoints.down("sm")]: {
    ...theme.components.MuiInputBase.styleOverrides.root,
    fontSize: "16px",
  },
};

const AppLayout = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          minHeight: "var(--100vh)",
        }}
      >
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            height: "var(--100vh)",
          }}
        >
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Box>
        <Notifier />
        <A11yMessage />
        {isAuthenticated && (
          <>
            <UpgradePlan />
            <TTSRequestsLimit />
            <CrazyEggTrackers />
          </>
        )}
      </Box>
    </ThemeProvider>
  );
};

AppLayout.propTypes = {};

export default AppLayout;
